window.addEventListener('load', function() {
  swiper = new Swiper('.confidence-swiper', {
    slidesPerView: 1,
    loop: true,
    // autoplay: {
    //   delay: 3000,
    // },
    breakpoints: {
      991: {
        slidesPerView: 4,
      },
    },
  });
});